/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/Footer.css";

import footerLine from "../../assets/footer_line.png";
import footerInfo from "../../assets/info.png";
import footerTiktok from "../../assets/footer_tiktok.png";
import footerWeb from "../../assets/footer_web.png";

export default function FooterTH(props) {
  const [lang, setLanguage] = useState(true);

  const changeLang = () => {
    props.onSelect(!lang);
    // setLanguage(!lang)
    // console.log(lang);
  };

  return (
    <div class="container-footer">
      <div className="menu-left">
        <p className="txt1">กลุ่มนวัตกรรมดิจิทัลสำหรับเมือง</p>
        <p className="txt1">
          สำนักงานพัฒนาวิทยาศาสตร์และเทคโนโลยีแห่งชาติ (สวทช.)
        </p>

        <p className="txt2">
          111 อุทยานวิทศาสตร์ประเทศไทย ถนนพหลโยธิน ตำบลคลองหนึ่ง อำเภอคลองหลวง
          จังหวัดปทุมธานี 12120
        </p>

        {/* <p className="txt3">เวลาทำการ จันทร์-ศุกร์ 9:00-16:00 น.</p> */}
        {/* <p className="txt3">โทรศัพท์: 086-901-6124</p> */}
      </div>

      <div className="menu-right">
        <div className="container-icon-and-txt">
          <a
            href="https://info.traffy.in.th/Help-Center-f7de9a3f310b4bcd8f307dfced4926b2"
            target="_blank"
            rel="noreferrer">
            <img src={footerInfo}></img>
          </a>
          <a
            className="txt1"
            href="https://info.traffy.in.th/Help-Center-f7de9a3f310b4bcd8f307dfced4926b2"
            target="_blank"
            rel="noreferrer">
            Traffy Info
          </a>
        </div>
        <div className="container-icon-and-txt">
          <a
            href="https://line.me/R/ti/p/%40155yjrwo"
            target="_blank"
            rel="noreferrer">
            <img src={footerLine}></img>
          </a>
          <div>
            <a
              className="txt1"
              href="https://line.me/R/ti/p/%40155yjrwo"
              target="_blank"
              rel="noreferrer">
              @fonduehelp
            </a>
            <p className="txt2">(สอบถามปัญหาระบบ)</p>
          </div>
        </div>
        <div className="container-icon-and-txt">
          <a
            href="https://www.tiktok.com/@traffyfondue"
            target="_blank"
            rel="noreferrer">
            <img src={footerTiktok}></img>
          </a>
          <a
            className="txt1"
            href="https://www.tiktok.com/@traffyfondue"
            target="_blank"
            rel="noreferrer">
            traffyfondue
          </a>
        </div>
        <div className="container-icon-and-txt">
          <a href="https://www.traffy.in.th/" target="_blank" rel="noreferrer">
            <img src={footerWeb}></img>
          </a>
          <a
            className="txt1"
            href="https://www.traffy.in.th/"
            target="_blank"
            rel="noreferrer">
            Traffy.in.th
          </a>
        </div>
      </div>
    </div>
  );
}
